import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import Scroll from 'react-scroll';

import { Home, Work, Photo, Resume } from './views';
import ProfileLinks from './components/ProfileLinks';
import ScrollToTopRoute from './components/ScrollToTopRoute';

const scroll = Scroll.animateScroll;

class App extends Component {

  constructor(props) {
    super(props);
    this.year = new Date().getFullYear();
  }

  handleScrollToTop() {
    scroll.scrollToTop();
  }

  render() {
    return (
      <div className="App">
        <header className="sticky">
          <nav className="header-nav">
            <NavLink activeClassName="active" to="/" exact>Home</NavLink>
            <NavLink activeClassName="active" to="/webdev">Work</NavLink>
            <NavLink activeClassName="active" to="/photo">Photo</NavLink>
            <NavLink activeClassName="active" to="/resume">Resume</NavLink>
          </nav>
        </header>
        <ScrollToTopRoute exact path="/" component={Home}/>
        <ScrollToTopRoute path="/webdev" component={Work}/>
        <ScrollToTopRoute path="/photo" component={Photo}/>
        <ScrollToTopRoute path="/resume" component={Resume}/>
        <footer>
          <div onClick={this.handleScrollToTop} style={{ width: '24px', margin: '0 auto', cursor: 'pointer' }} aria-label="Back to top" title="Back to top">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M35.5 279.9l148-148.4c4.7-4.7 12.3-4.7 17 0l148 148.4c4.7 4.7 4.7 12.3 0 17l-19.6 19.6c-4.8 4.8-12.5 4.7-17.1-.2L218 219.2V468c0 6.6-5.4 12-12 12h-28c-6.6 0-12-5.4-12-12V219.2l-93.7 97.1c-4.7 4.8-12.4 4.9-17.1.2l-19.6-19.6c-4.8-4.7-4.8-12.3-.1-17zM12 84h360c6.6 0 12-5.4 12-12V44c0-6.6-5.4-12-12-12H12C5.4 32 0 37.4 0 44v28c0 6.6 5.4 12 12 12z"/></svg>
          </div>
          <ProfileLinks></ProfileLinks>
          <div className="copyright">&copy; {this.year} Peter Liu</div>
        </footer>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js